import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck, Phone } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { SITE } from "@/lib/site";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await login(username, password);
    setBusy(false);
    if (r.ok) {
      toast.success("Hoş geldiniz");
      navigate("/admin", { replace: true });
    } else {
      toast.error(r.error || "Giriş başarısız");
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-[#0a0a0a] text-white" data-testid="login-page">
      <div className="relative hidden lg:block grain">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${SITE.hero})` }} />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/70 to-[#0a0a0a]/30" />
        <div className="relative h-full p-12 flex flex-col justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="login-brand">
            <img src={SITE.logo} alt="Kardeşler Yapı" className="h-12 w-12 rounded-sm object-cover ring-1 ring-[#d4af37]/40" />
            <div>
              <div className="font-display tracking-tight text-lg">KARDEŞLER YAPI</div>
              <div className="font-mono text-[10px] tracking-[0.32em] text-[#d4af37]">A D M I N · C R M</div>
            </div>
          </Link>
          <div>
            <h1 className="font-display font-extrabold tracking-tighter text-6xl leading-[0.9]">
              Şantiyenin
              <br /><span className="text-[#d4af37]">Lüks Komuta Merkezi.</span>
            </h1>
            <p className="text-white/55 mt-6 max-w-md">Binalar, daire ödemeleri, malzeme, personel ve yap-sat projelerinizi tek panelden yönetin.</p>
          </div>
          <div className="font-mono text-[11px] tracking-[0.3em] uppercase text-white/40 flex items-center gap-2">
            <Phone className="h-3 w-3 text-[#d4af37]" /> {SITE.phones[0].label}
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="login-form">
          <div className="lg:hidden mb-8">
            <Link to="/" className="inline-flex items-center gap-3">
              <img src={SITE.logo} alt="logo" className="h-10 w-10 rounded-sm object-cover ring-1 ring-[#d4af37]/40" />
              <span className="font-display tracking-tight">KARDEŞLER YAPI</span>
            </Link>
          </div>
          <ShieldCheck className="h-10 w-10 text-[#d4af37]" />
          <h2 className="mt-6 font-display font-extrabold tracking-tighter text-5xl">Yönetici Girişi</h2>
          <p className="text-white/55 mt-2 text-sm">Sadece yetkili personel için. Tüm işlemler kayıt altına alınır.</p>
          <div className="mt-8 space-y-5">
            <div>
              <label className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/45">Kullanıcı Adı</label>
              <input data-testid="login-username" autoComplete="username" value={username} onChange={(e) => setUsername(e.target.value)} className="mt-2 w-full bg-transparent border-b border-white/15 focus:border-[#d4af37] py-3 outline-none text-white" required />
            </div>
            <div>
              <label className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/45">Şifre</label>
              <input data-testid="login-password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 w-full bg-transparent border-b border-white/15 focus:border-[#d4af37] py-3 outline-none text-white" required />
            </div>
          </div>
          <button
            type="submit"
            data-testid="login-submit"
            disabled={busy}
            className="mt-8 w-full bg-[#d4af37] text-[#121212] hover:bg-white disabled:opacity-60 py-4 font-display uppercase tracking-[0.2em] text-sm transition"
          >
            {busy ? "Giriş yapılıyor..." : "Panele Giriş Yap →"}
          </button>
          <Link to="/" className="mt-6 inline-block text-xs text-white/40 hover:text-[#d4af37] transition font-mono uppercase tracking-[0.25em]">
            ← Siteye Dön
          </Link>
        </form>
      </div>
    </div>
  );
}
